// extracted by mini-css-extract-plugin
export var container = "Box-module--container--RJG0K";
export var dark = "Box-module--dark--eERB2";
export var heading = "Box-module--heading--NSng-";
export var light = "Box-module--light--dbSkE";
export var number = "Box-module--number--g3n2T";